<template>
  <div class="root-box">
    <el-table :data="displayList" stripe :max-height="tableHeight">
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column prop="date" width="100" label="日期"></el-table-column>
      <el-table-column prop="pathId" width="120" label="路线">
        <template slot-scope="scope">{{ scope.row.pathId | pathNameTransfer }}</template>
      </el-table-column>
      <el-table-column prop="showTime" width="120" label="时间"></el-table-column>
      <el-table-column prop="orderSource" width="100" label="渠道">
        <template slot-scope="scope">
          <div v-order-source="scope.row.orderSource"></div>
          <vip-label :vip="scope.row.vip" />
        </template>
      </el-table-column>
      <el-table-column prop="number" width="60" label="订票">
        <template slot-scope="scope">
          {{ scope.row | orderTypeTransfer }}
        </template>
      </el-table-column>
      <el-table-column prop="price" width="100" label="总价">
        <template slot-scope="scope">{{ scope.row.price | moneyFormat }}元</template>
      </el-table-column>
      <el-table-column prop="telephone" width="130" label="手机">
        <template slot-scope="scope">
          <tel-cell :order="scope.row" />
        </template>
      </el-table-column>
      <el-table-column prop="departure" label="起点"></el-table-column>
      <el-table-column prop="destination" label="终点"></el-table-column>
      <el-table-column prop="payStatus" width="80" label="支付状态">
        <template slot-scope="scope">
          <span :class="{ red: scope.row.payStatus === 0 }">{{
            scope.row.payStatus | enumTransfer(payStatusOpts)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100" prop="createTime" label="下单时间"></el-table-column>
    </el-table>
    <div class="page">
      <span class="pagination-sum">共{{ list.length }}单， {{ totalPerson }}人</span>
    </div>
  </div>
</template>

<script>
import TelCell from "@/components/TelCell";
import { mapState } from "vuex";

export default {
  components: { TelCell },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    date: {
      type: String,
      default: ""
    },
    tableHeight: {
      type: Number,
      default: 850
    }
  },
  computed: {
    ...mapState({
      payStatusOpts: (state) => state.enumMap["PAY_STATUS"]
    }),
    displayList() {
      return (this.list || []).map((item) => ({
        ...item,
        date: this.date || item.date
      }));
    },
    totalPerson() {
      return (this.list || []).reduce((sum, item) => sum + (item.number || 0), 0);
    }
  }
};
</script>

<style lang="less" scoped>
.root-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page {
  flex-shrink: 0;
  padding-top: 4px;
  line-height: 18px;
  box-sizing: border-box;
  height: 30px;
}

.pagination-sum {
  color: #f56c6c;
  font-size: 15px;
  display: inline-block;
}

.red {
  color: #f56c6c;
}
</style>
